import styled from 'styled-components/macro';
import { Button } from '@yme/atoms/button';
import { colorBlackTransparent100, colorBlackTransparent600, colorCoreBlack900Base, colorCoreGray500, colorCoreWhite1000, } from '@yme/tokens/colors';
import { CORNER_RADIUS } from '@yme/tokens/cornerRadius';
import { ADAPTIVE } from '@yme/tokens/screen';
import { INDENT } from '@yme/tokens/sizes';
import { Z_INDEX } from '@yme/tokens/zindex';
import { getTextStyles } from '@yme/utils/styles';
export const Overlay = styled.div `
  z-index: ${Z_INDEX.popupLevel1};
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: ${colorBlackTransparent600};
`;
export const LightboxContainer = styled.section `
  position: fixed;
  top: 50%;
  left: 50%;
  max-width: 1116px;
  width: 119vh;
  box-sizing: border-box;

  background-color: ${colorCoreWhite1000};
  border-radius: ${CORNER_RADIUS.m};
  transform: translate(-50%, -50%);

  @media only screen and (max-width: 1160px) {
    max-width: 1024px;
  }

  ${ADAPTIVE.maxWidth.tablet} {
    display: flex;
    flex-direction: column;
    justify-content: space-between;
    width: 100%;
    height: 100%;
    border-radius: 0;
  }
`;
export const LightboxHeader = styled.div `
  min-height: 60px;
  padding: ${INDENT.xs} ${INDENT.sm};
  box-sizing: border-box;

  ${getTextStyles('Ubuntu', 500, 18, 28)};

  color: ${colorCoreBlack900Base};
  border-bottom: 1px solid ${colorCoreGray500};

  ${ADAPTIVE.maxWidth.mobile} {
    padding: ${INDENT.xs};
  }
`;
export const CloseButton = styled(Button) `
  position: absolute;
  top: 12px;

  ${({ isRightToLeft }) => (isRightToLeft ? 'left: 12px' : 'right: 12px')};

  &:hover {
    background-color: ${colorBlackTransparent100};
  }
`;
